(() => {
  const updateCardFromVariantSource = (source) => {
    const card = source.closest('.bm2-prod');
    if (!card) return;

    const title = card.querySelector('[data-bm2-variant-title]');
    const price = card.querySelector('[data-bm2-variant-price]');
    const image = card.querySelector('[data-bm2-product-image]');
    const variantInput = card.querySelector('[data-bm2-product-variant-id]');
    const addButton = card.querySelector('[data-bm2-add-button]');
    const addLabel = card.querySelector('[data-bm2-add-label]');
    const variantId = source.getAttribute('data-bm2-variant-id') || source.value || '';
    const variantUrl = source.getAttribute('data-bm2-variant-url') || '';
    const isAvailable = source.getAttribute('data-bm2-variant-available') !== 'false';
    const variantImage = source.getAttribute('data-bm2-variant-image') || '';

    card.querySelectorAll('[data-bm2-variant-id]').forEach((button) => {
      const isCurrent = button.getAttribute('data-bm2-variant-id') === variantId;
      if (!button.classList.contains('bm2-prod__swatch')) return;
      button.classList.toggle('is-selected', isCurrent);
      button.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
    });

    if (title) title.textContent = source.getAttribute('data-bm2-variant-title') || '';

    if (price) {
      const variantPrice = source.getAttribute('data-bm2-variant-price') || '';
      const comparePrice = source.getAttribute('data-bm2-variant-compare') || '';
      price.innerHTML = comparePrice ? `<span>${variantPrice}</span><br><s>${comparePrice}</s>` : `<span>${variantPrice}</span>`;
    }

    if (image && variantImage) {
      image.setAttribute('src', variantImage);
      if (source.getAttribute('data-bm2-variant-srcset')) {
        image.setAttribute('srcset', source.getAttribute('data-bm2-variant-srcset'));
      }
    }

    if (variantInput && variantId) variantInput.value = variantId;

    if (addButton) {
      addButton.disabled = !isAvailable;
      addButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      addButton.setAttribute('type', 'submit');
      if (addLabel) {
        addLabel.textContent = isAvailable
          ? addButton.getAttribute('data-bm2-add-text') || addLabel.textContent
          : addButton.getAttribute('data-bm2-sold-out-text') || addLabel.textContent;
      }
    }

    card.querySelectorAll('[data-bm2-product-link]').forEach((link) => {
      if (variantUrl) link.setAttribute('href', variantUrl);
    });
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-bm2-variant-id]');
    if (!swatch) return;

    event.preventDefault();
    updateCardFromVariantSource(swatch);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bm2-variant-select]');
    if (!select) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;
    updateCardFromVariantSource(option);
  });
})();
